import _ from 'lodash'
import { SET_PROCESS_RUNNING } from './constants'

// Initial state of the store
const initialState = {}
// Sample state:
// {
//     tq: { // <- server name
//         ccp_rubik: false // <- process status
//     },
// }

const process = (state = initialState, action) => {
    switch (action.type) {
        // Update the process running status for a given user
        case SET_PROCESS_RUNNING: {
            const clone = _.cloneDeep(state)
            const { serverId, userId, isRunning } = action.payload

            // If server is missing, add it
            if (clone[serverId] === undefined) {
                clone[serverId] = {}
            }

            // Update isRunning status
            clone[serverId][userId] = isRunning

            return clone
        }

        // Default state
        default:
            return state
    }
}

export default process



// WEBPACK FOOTER //
// ./src/features/Backend/data/process/reducer.js